export default "__VITE_ASSET__Tn1a0_OU__";